import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import classNames from "classnames";

export type SortKey = string | { first: string; second: string };

export type TableColumn = {
  sortKey: SortKey;
  title: string;
};

export type SortOrder = "1" | "-1";

type Props = {
  sortColumn?: (sortKey: SortKey) => () => void;
  sortKey?: SortKey;
  sortDirection?: SortOrder;
  sortingBy?: SortKey;
  children?: React.ReactNode;
  className?: string;
  isLast?: boolean;
};

const ColumnHeader = ({
  sortColumn,
  sortKey,
  sortDirection,
  sortingBy,
  children,
  className,
  isLast,
}: Props) => {
  const rootClassName = classNames(
    className,
    "py-3 text-faux-whirlpool text-center text-xs uppercase tracking-wider dark:text-primary-100 bg-faux-dark-gunmetal",
  );

  return (
    <th
      scope="col"
      onClick={sortColumn && sortKey ? sortColumn(sortKey) : () => null}
      className={rootClassName}
    >
      <div
        className={classNames(
          "flex flex-row items-center justify-center",
          isLast && "justify-end",
        )}
      >
        <span
          className={classNames(
            "mr-2",
            !!sortKey && sortKey === sortingBy
              ? "text-white"
              : "text-faux-whirlpool",
          )}
        >
          {children}
        </span>
        {!!sortKey && sortKey === sortingBy ? (
          sortKey && sortDirection === "-1" ? (
            <KeyboardArrowDownIcon
              className="h-5 w-5 text-white"
              aria-hidden="true"
              fontSize="small"
            />
          ) : (
            <KeyboardArrowUpIcon
              className="h-5 w-5 text-white"
              aria-hidden="true"
              fontSize="small"
            />
          )
        ) : (
          !!sortKey && (
            <div>
              <UnfoldMoreIcon
                className="text-faux-whirlpool"
                fontSize="small"
              />
            </div>
          )
        )}
      </div>
    </th>
  );
};

export default ColumnHeader;
